import { jwtDecode } from 'jwt-decode';
import { CustomJwtPayload, UserDataJwtPayload } from 'ts-types';

export const extractUserDataFromJwtToken = (
  token: string | null
): UserDataJwtPayload => {
  const decodeJwt =
    token !== null
      ? jwtDecode<CustomJwtPayload>(token)
      : ({} as CustomJwtPayload);
  return {
    permissions: decodeJwt?.permissions || [],
    username: decodeJwt?.username || null,
    partnerName: decodeJwt?.partnerName,
    id: decodeJwt?.id,
    role: decodeJwt.role,
    status: decodeJwt?.status,
    email: decodeJwt?.email,
    isEmailVerificationRequired: decodeJwt?.isEmailVerificationRequired,
    isEmailVerified: decodeJwt?.isEmailVerified,
  };
};
